import React, { Component } from 'react';
import {
  Modal, Button, InfoTooltip,
} from 'framework-ui-components';
import LogoScadenze from './LogoScadenze';

class ModaleScadenze extends Component {
  render() {
    const { delegatoCentrale, prossimaScadenza, onClose } = this.props;
    console.log(delegatoCentrale);
    return (
      <Modal show onClose={onClose} contentClassName="modale-Scadenze">
        <Modal.Header>Elenco scadenze 730 2020</Modal.Header>
        <Modal.Body>
          <ul className="elenco-scadenze">
            {prossimaScadenza <= 0
              && (
                <li><b>Scadenza 23 agosto ore 24.00</b><br />
                    Le dichiarazioni (con richiesta del precompilato in stato "evasa" <InfoTooltip>
                    Puoi verificare lo stato delle richieste del precompilato dal servizio "Richiesta Enti".
                                                                                      </InfoTooltip>
                    ) trasmesse a CGN entro questa scadenza saranno inviate all'Agenzia delle Entrate per consentire i conguagli entro la prima mensilit&agrave; utile.
                </li>
              )}
            {prossimaScadenza <= 1
              && (
                <li><b>Scadenza 31 agosto ore 24.00</b><br />
                    Le dichiarazioni trasmesse a CGN entro questa scadenza saranno inviate all'Agenzia delle Entrate <InfoTooltip>
                      <p>La gestione operativa dell'invio all'Agenzia delle Entrate richiederà qualche giorno.</p>
                                                                                                                     </InfoTooltip> come previsto dalla normativa.
                </li>
              )}
            {prossimaScadenza <= 2
              && (
                <li><b>Scadenza 22 settembre ore 24.00</b><br />
                    Le dichiarazioni (con richiesta del precompilato in stato "evasa" <InfoTooltip>
                    Puoi verificare lo stato delle richieste del precompilato dal servizio "Richiesta Enti".
                                                                                      </InfoTooltip>
                    ) trasmesse a CGN entro questa scadenza saranno inviate all'Agenzia delle Entrate <InfoTooltip>
                      <p>La gestione operativa dell'invio all'Agenzia delle Entrate richiederà qualche giorno.</p>
                                                                                                      </InfoTooltip> per consentire i conguagli entro la prima mensilit&agrave; utile.
                </li>
              )}
            {!delegatoCentrale && (
              <li><b className="ultimaScadenza">Scadenza 28 settembre ore 23.00</b> <InfoTooltip>
                Ti chiediamo di trasmettere tutte le dichiarazioni a CGN con 2 giorni di anticipo rispetto alla chiusura normativa della Campagna Fiscale (30/09) per permetterci la gestione operativa dell'invio all'Agenzia della Entrate.
                                                                                    </InfoTooltip><br />
                Le dichiarazioni trasmesse a CGN entro questa scadenza saranno inviate all'Agenzia delle Entrate per la chiusura della campagna fiscale.
              </li>
            )}
            {delegatoCentrale && (
              <li><b className="ultimaScadenza">Scadenza 27 settembre ore 23.00</b> <InfoTooltip>
                Ti chiediamo di trasmettere tutte le dichiarazioni a CGN con 5 giorni di anticipo rispetto alla chiusura normativa della Campagna Fiscale (30/09) per permetterci la gestione operativa dell'invio all'Agenzia della Entrate.
                                                                                    </InfoTooltip><br />
                Le dichiarazioni trasmesse a CGN entro questa scadenza saranno inviate all'Agenzia delle Entrate per la chiusura della campagna fiscale.
              </li>
            )}
          </ul>
          <span className="stileLogoScadenze"><LogoScadenze /></span>
        </Modal.Body>
        <Modal.Footer>
          <Button flat primary onClick={onClose}>HO CAPITO</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModaleScadenze;
